export const BULK_FIELD_NAME = 'bulk_field'
